<template>
  <VView class="prizes" back-button-to="/menu" :header="$t('prizes.header')">
    <VText center>Nagroda główna</VText>

    <VBlock max-width="818px">
      <img src="@/assets/prizes-1.png" />
    </VBlock>

    <VText center>24x nagrody dodatkowe</VText>

    <VBlock max-width="651px">
      <img src="@/assets/prizes-2.png" />
    </VBlock>
  </VView>
</template>

<script>
export default {
  name: 'Prizes',
};
</script>

<style lang="scss" scoped>
.prizes {}
</style>
